import type { AccessManifest } from "@/auth/AccessManifestProvider";
import { canAccessAppView, defaultAuthorizedView } from "@/auth/accessNavigation";

export interface ManifestNavigationInput {
    manifest: AccessManifest;
    currentView: string;
    requestedView: string | null;
    hydrateFromLocation: boolean;
}

export interface ManifestNavigationDecision {
    view: string;
    replaceRoute: boolean;
}

/**
 * Keeps authorization revalidation independent from URL hydration.
 *
 * The browser location is authoritative on the initial hydration (and
 * popstate is handled explicitly by App). A background access-manifest
 * refresh must not reinterpret a stale pathname and undo in-app navigation.
 */
export function resolveManifestNavigation({ manifest, currentView, requestedView, hydrateFromLocation }: ManifestNavigationInput): ManifestNavigationDecision {
    if (hydrateFromLocation && requestedView) {
        if (canAccessAppView(manifest, requestedView)) {
            return { view: requestedView, replaceRoute: false };
        }
        return {
            view: defaultAuthorizedView(manifest),
            replaceRoute: true
        };
    }

    if (canAccessAppView(manifest, currentView)) {
        return { view: currentView, replaceRoute: false };
    }

    return {
        view: defaultAuthorizedView(manifest),
        replaceRoute: true
    };
}
